import { memo, useCallback } from 'react';
import { Key } from 'ts-key-enum';
import { useNavigate } from 'react-router-dom';
import { Box, styled, useTheme } from '@mui/material';
import { SearchInput, TicketSearchInOrg } from '@tymely/components';
import { useAppMode, AppMode } from '@tymely/services';
import { useHotKeyFocus } from '@tymely/utils';
import { useSearchTickets } from '@tymely/api';
import { ITicket } from '@tymely/atoms';

const StyledSearch = styled(SearchInput)(({ theme }) => ({
    '& .MuiInputBase-input': {
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(12),
            '&:focus': {
                width: theme.spacing(20),
            },
        },
    },
}));

export const TicketSearch = memo((props: { hideOrgSearch: boolean }) => {
    const theme = useTheme();
    const searchRef = useHotKeyFocus([Key.Control, Key.Alt, 'KeyT']);
    const { appMode, navigateTicket } = useAppMode();
    const navigate = useNavigate();

    const onSearch = useCallback(
        (ticketId: string) => {
            navigateTicket(ticketId, appMode === AppMode.Online ? AppMode.Training : appMode);
        },
        [navigateTicket, navigate, appMode],
    );

    const onSubmit = useCallback(
        (ticket: ITicket) => {
            if (ticket) {
                onSearch(String(ticket.id));
            }
        },
        [onSearch],
    );

    const searchTickets = useSearchTickets();

    return (
        <>
            <Box ml={2} mr={2}>
                <StyledSearch
                    input={{
                        inputProps: { 'aria-label': 'search' },
                        placeholder: 'Search…',
                        inputRef: searchRef,
                    }}
                    onSubmit={onSearch}
                />
            </Box>
            {!props.hideOrgSearch && (
                <Box sx={{ display: 'none', [`${theme.breakpoints.up('md')}`]: { display: 'flex' } }}>
                    <TicketSearchInOrg searchApi={searchTickets} onSubmit={onSubmit} />
                </Box>
            )}
        </>
    );
});

TicketSearch.displayName = 'TicketSearch';
